(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["riaz-mega-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('riaz-navigation')) {
    customElements.define('riaz-navigation', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.mobile = matchMedia('(max-width: 1099px)');
        this.surface = this.querySelector('.riaz-nav-surface');
        this.trigger = this.closest('.riaz-header').querySelector('.riaz-menu-open');
        this.roots = [...this.querySelectorAll('.riaz-root-disclosure')];
        this.groups = [...this.querySelectorAll('.riaz-nav-group')];
        this.setAttribute('data-enhanced', '');
        this.trigger.addEventListener('click', () => this.openDrawer(), {signal});
        this.querySelectorAll('[data-riaz-close]').forEach(el => el.addEventListener('click', () => this.closeDrawer(), {signal}));
        this.surface.addEventListener('cancel', event => { event.preventDefault(); this.closeDrawer(); }, {signal});
        this.surface.addEventListener('click', event => {
          if (event.target !== this.surface || !this.mobile.matches) return;
          const rect = this.surface.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeDrawer();
        }, {signal});
        this.roots.forEach(root => {
          const summary = root.querySelector(':scope > summary');
          summary.addEventListener('click', () => {
            if (!root.open) this.roots.forEach(other => { if (other !== root) other.open = false; });
          }, {signal});
          root.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(root.open)), {signal});
          summary.addEventListener('keydown', event => {
            if (event.key === 'ArrowDown' && !this.mobile.matches) {
              event.preventDefault();
              this.roots.forEach(other => { other.open = other === root; });
              root.querySelector('.riaz-mega-panel a')?.focus();
            }
          }, {signal});
        });
        this.groups.forEach(group => group.querySelector('summary').addEventListener('click', event => {
          if (!this.mobile.matches) event.preventDefault();
        }, {signal}));
        document.addEventListener('pointerdown', event => {
          if (!this.contains(event.target) && !this.trigger.contains(event.target) && !this.mobile.matches) this.closePanels();
        }, {signal});
        document.addEventListener('keydown', event => this.onKey(event), {signal});
        this.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            if (!this.mobile.matches && !this.contains(document.activeElement)) this.closePanels();
          });
        }, {signal});
        this.mobile.addEventListener('change', () => this.setMode(), {signal});
        this.resizeObserver = new ResizeObserver(() => {
          document.documentElement.style.setProperty('--header-height', `${this.closest('.header-section').offsetHeight}px`);
        });
        this.resizeObserver.observe(this.closest('.header-section'));
        this.querySelectorAll('[data-rh-mega]').forEach(mega => {
          const tabs = [...mega.querySelectorAll('[data-rh-tab]')];
          tabs.forEach((tab,index) => {
            tab.addEventListener('click', () => this.selectCategory(mega,index), {signal});
            tab.addEventListener('keydown', event => {
              let next = index;
              if (event.key === 'ArrowDown') next = (index+1)%tabs.length;
              else if (event.key === 'ArrowUp') next = (index-1+tabs.length)%tabs.length;
              else if (event.key === 'Home') next = 0;
              else if (event.key === 'End') next = tabs.length-1;
              else return;
              event.preventDefault(); this.selectCategory(mega,next); tabs[next].focus();
            }, {signal});
          });
        });
        this.setMode();
      }
      selectCategory(mega,index) {
        const tabs = [...mega.querySelectorAll('[data-rh-tab]')];
        const groups = [...mega.querySelectorAll('[data-rh-group]')];
        mega.dataset.selected = String(index);
        tabs.forEach((tab,i) => { tab.setAttribute('aria-selected',String(i===index)); tab.tabIndex = i===index ? 0 : -1; });
        groups.forEach((group,i) => { group.hidden = !this.mobile.matches && i!==index; group.open = !this.mobile.matches; if (!this.mobile.matches) { group.setAttribute('role','tabpanel'); group.setAttribute('aria-labelledby',tabs[i].id); } else { group.removeAttribute('role'); group.removeAttribute('aria-labelledby'); } });
      }
      closePanels() { this.roots.forEach(root => { root.open = false; }); }
      setMode() {
        this.closeDrawer(false);
        this.closePanels();
        this.groups.forEach(group => {
          group.open = !this.mobile.matches;
          group.querySelector('summary').setAttribute('tabindex', this.mobile.matches ? '0' : '-1');
        });
        this.querySelectorAll('[data-rh-mega]').forEach(mega => this.selectCategory(mega,Number(mega.dataset.selected)||0));
        this.surface.inert = this.mobile.matches;
        if (this.mobile.matches) {
          this.surface.close();
          this.surface.setAttribute('role', 'dialog');
          this.surface.setAttribute('aria-label', this.querySelector('nav').getAttribute('aria-label'));
          this.surface.setAttribute('aria-modal', 'true');
        } else {
          this.surface.setAttribute('open', '');
          this.surface.setAttribute('role', 'presentation');
          this.surface.removeAttribute('aria-modal');
          this.surface.removeAttribute('aria-label');
        }
      }
      openDrawer() {
        if (!this.mobile.matches || this.hasAttribute('data-open')) return;
        this.lastFocus = document.activeElement;
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.setAttribute('data-open', '');
        this.surface.inert = false;
        this.surface.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        this.querySelector('.riaz-menu-close').focus();
      }
      closeDrawer(restore = true) {
        const wasOpen = this.hasAttribute('data-open');
        this.removeAttribute('data-open');
        this.trigger?.setAttribute('aria-expanded', 'false');
        if (wasOpen) {
          this.surface.close();
          document.body.style.overflow = this.previousOverflow || '';
          if (restore) this.lastFocus?.focus();
        }
        if (this.mobile?.matches) this.surface.inert = true;
      }
      onKey(event) {
        if (event.key === 'Escape') {
          if (this.hasAttribute('data-open')) { event.preventDefault(); this.closeDrawer(); }
          else {
            const activeRoot = this.roots.find(root => root.open);
            if (activeRoot) { event.preventDefault(); this.closePanels(); activeRoot.querySelector('summary').focus(); }
          }
        }
        if (event.key === 'Tab' && this.hasAttribute('data-open')) {
          const elements = [...this.surface.querySelectorAll('a[href], button, input:not([type=hidden]), summary')].filter(el => el.getClientRects().length && el.tabIndex !== -1);
          const first = elements[0];
          const last = elements[elements.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      }
      disconnectedCallback() {
        this.closeDrawer(false);
        this.abort?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
